import { render, staticRenderFns } from "./CollapsibleList.vue?vue&type=template&id=79f099ee&scoped=true&"
import script from "./CollapsibleList.vue?vue&type=script&lang=js&"
export * from "./CollapsibleList.vue?vue&type=script&lang=js&"
import style0 from "./CollapsibleList.vue?vue&type=style&index=0&id=79f099ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f099ee",
  null
  
)

export default component.exports